const isArticlePage = (): boolean => {
  return (
    document.body.classList.contains("single-post") ||
    document.body.classList.contains("post-template-default") ||
    document.querySelector("main.single-post") !== null ||
    document.querySelector(".single-post") !== null
  );
}

export default isArticlePage;